module.exports = __webpack_public_path__ + "static/img/小腿套.2f2b913d.jpg";